// src/layouts/RootLayout.js
import React from 'react';
import Nav from '../Components/Navbar';
import Footer from '../Components/Footer';
import WhatsAppButton from '../Components/ui/WhatsAppButton';


const RootLayout = ({ children }) => {
  return (
    <>
      <Nav />
      {children}
      <WhatsAppButton 
        buttonText='Chat on WhatsApp'
        message=""
      />
      <Footer />
    </>
  );
};

export default RootLayout;